<div>
  <!-- list controls -->
  <div *ngIf="!simplified" class="clearfix">

    <!-- type filter -->
    <ls-dropdown *ngIf="typeOptions.length > 0" class="pull-right" [placement]="'right'">
      <ls-dropdown-toggle>
        <div class="filter-bar d-inline-block">
          <strong>Showing:</strong>
          <a href (click)="false">
            {{ filterLabel }}
            <span class="ls1"><span class="caret"></span></span>
          </a>
        </div>
      </ls-dropdown-toggle>
      <ls-dropdown-menu>
        <div class="tw-p-2">
          <a href="javascript:" (click)="clearFilter()">Clear</a>
          <div class="checklist-block">
            <checklist [options]="typeOptions" (change)="filter()" (click)="$event.stopPropagation()"></checklist>
          </div>
        </div>
      </ls-dropdown-menu>
    </ls-dropdown>

  </div>

  <!-- list -->
  <div class="activity-stream-content tab-pane-content">
    <div class="activity-stream-list">
      <p *ngIf="error">No activities loaded. Please try again later.</p>
      <borrower-activity *ngFor="let activity of (activities$ | async)" [borrower]="borrower" [activity]="activity" [simplified]="simplified"></borrower-activity>
    </div>
  </div>

  <!-- load more -->
  <div class="tw-py-6 tw-grid tw-grid-flow-col tw-justify-center">
    <button *ngIf="!(activitiesLoading$ | async) else loading" (click)="loadMore()" class="btn btn-primary btn-action">Load More</button>

    <ng-template #loading>
      <mat-spinner diameter="38"></mat-spinner>
    </ng-template>
  </div>

</div>
